import { render, staticRenderFns } from "./ApiRequests.vue?vue&type=template&id=243fa6c2"
import script from "./ApiRequests.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiRequests.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports